export function validateColumns(value: string) {
  const rawFields = value.split(',').map(f => f.trim());
  const seen = new Set();

  const normalRegex = /^[a-zA-Z0-9_-]+$/;
  const inputRegex = /^-[a-zA-Z0-9_-]+(?::(text|number))?(?::required)?$/;

  for (let field of rawFields) {
    if (!field) return false;

    let isInput = field.startsWith('-');

    if (!isInput && !normalRegex.test(field)) {
      return false;
    }

    if (isInput && !inputRegex.test(field)) {
      return false;
    }

    const key = field.replace(/^-/, '').split(':')[0];
    if (seen.has(key)) return false;
    seen.add(key);
  }

  return true;
}

export function parseColumns(value: string) {
  if (!value) return [];
  if (!validateColumns(value)) return [];
  const rawFields = value.split(',').map(f => f.trim());

  return rawFields.map(field => {
    let isInput = field.startsWith('-');
    let clean = isInput ? field.slice(1) : field;

    const parts = clean.split(':');
    const fieldName = parts[0];
    const type = parts.find(p => p === 'text' || p === 'number') || null;
    const required = parts.includes('required');

    return {
      field: fieldName,
      input: isInput,
      type: type || (isInput ? 'text' : null),
      required
    };
  });
}
